export enum TenantsKeys {
  TENANT = 'tenant',
  TENANTS_LIST = 'tenants_list',
}
